module.exports = __webpack_public_path__ + "img/menu_grid_click.1e0d55a5.svg";